import { UserRoles } from '../enums';

export const RolesValueSelect: SelectProps[] = [
  { label: 'Administrador', value: UserRoles.ADMIN },
  { label: 'Espectador', value: UserRoles.SPECTATOR },
];
